import React from "react";
import TimePicker from "./TimePicker";

export default function AlarmControl({
    onSetAlarm,
    onCancelAlarm,
    currentAlarm,
    isActive,
    currentSound,
}) {
    const [hours, setHours] = React.useState("");
    const [minutes, setMinutes] = React.useState("");
    const [sound, setSound] = React.useState(currentSound || "beep");

    const sounds = [
        { value: 'classic', label: 'Réveil classique' },
        { value: 'tick', label: 'Tic-tac' },
        { value: 'telephone', label: 'Téléphone vintage' },
        { value: 'flute', label: 'Flûte mélodique ' },
        { value: 'orchestra', label: 'Orchestre épique' },
    ];

    function handleTimeChange(newHour, newMinute) {
        setHours(newHour);
        setMinutes(newMinute);
    }

    function handleSetAlarm() {
        if (hours === "" || minutes === "") {
            alert("Veuillez sélectionner une heure et des minutes valides");
            return;
        }

        const h = parseInt(hours, 10);
        const m = parseInt(minutes, 10);

        onSetAlarm(h, m, sound);
    }

    return (<>
        <h3 className="text-lg sm:text-xl font-bold text-center mb-4 text-gray-900">
            Régler le réveil
        </h3>
        <div className="bg-stone-100 rounded-lg p-4 sm:p-6 my-2 sm:my-4">

            {isActive && currentAlarm && (
                <div className="bg-green-200 border rounded-lg p-3 mb-4 text-center">
                    <div className="text-sm text-green-800 mb-1">
                        Réveil programmé pour
                    </div>
                    <div className="text-2xl font-bold text-green-900">
                        {String(currentAlarm.hours).padStart(2, "0")}:
                        {String(currentAlarm.minutes).padStart(2, "0")}
                    </div>
                </div>
            )}

            <div className="space-y-4">
                {/* Time Picker */}
                <div>
                    <TimePicker onTimeChange={handleTimeChange} showNow={true} />
                </div>

                {/* Sound Selection */}
                <div>
                    <label
                        htmlFor="alarm-sound"
                        className="block text-sm font-semibold text-gray-700 mb-2"
                    >
                        Sonnerie
                    </label>
                    <select
                        id="alarm-sound"
                        value={sound}
                        onChange={(e) => setSound(e.target.value)}
                        className="input select"
                    >
                        {sounds.map((s) => (
                            <option key={s.value} value={s.value}>
                                {s.label}
                            </option>
                        ))}
                    </select>
                </div>

                {/* Action Buttons */}
                <div className="flex gap-2">
                    <button
                        onClick={handleSetAlarm}

                        className="flex-1 cursor-pointer bg-logob-700 hover:bg-logob-600 text-white shadow-sm active:bg-logob-500 active:text-white focus:ring focus:ring-slate-300 w-1/2 rounded-lg px-2 sm:px-4 py-2 sm:py-4"
                    >
                        {isActive ? "Modifier" : "Activer"}
                    </button>
                    {isActive && (
                        <button
                            onClick={onCancelAlarm}
                            className="flex-1 cursor-pointer bg-red-700 hover:bg-red-600 text-white shadow-md active:bg-red-400 active:text-white focus:ring focus:ring-slate-300 w-1/2 rounded-lg px-2 sm:px-4 py-2 sm:py-4"
                        >
                            Annuler
                        </button>
                    )}
                </div>
            </div>
        </div>
    </>
    );
}